module.exports = __webpack_public_path__ + "assets/img/normal_priority.9cc0a5d3.svg";